import FaqAccordion from "@/components/common/FaqAccordion";
import { useTranslation } from "react-i18next";
import Plans from "@/components/tabs/overview/Plans";
import AboutSection from "@/components/tabs/overview/AboutSection";

const FAQ = ({ onPurchase }: { onPurchase: (planId: string) => void }) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div className="space-y-6 bg-slate-50 px-4 xl:px-0">
        <div className="px-4 pt-4 pb-4">
          <h2 className="text-3xl font-semibold">{t('faq.title')}</h2>
        </div>
        <FaqAccordion showAll />
      </div>
      <Plans onPurchase={onPurchase} />
      <AboutSection />
    </div>
  );
};

export default FAQ;
